import { Fragment, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import { TableContainer } from "@mui/material";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { ThemeProvider } from "@emotion/react";
import TableFooter from "@mui/material/TableFooter";
import { TableThem } from "../../../styles/TableThem";
import useAxios from "../../../hook/useAxios";
import { useTranslation } from "react-i18next";
import { GrowthStage } from "../../../type/growthStage";
import TableHeader from "../../Global/TableHeader";
import TablePagination from "../../Global/TablePagination";
import BotanicalFamilyTableItem from "./BotanicalFamilyTableItem";
import Loading from "../../Global/Loading";

const BotanicalFamilyTableContent: React.FC<{
  search: string;
  link: string;
  title: string;
  deleteMessage: string;
  editLink: string;
}> = ({ link, search, title, deleteMessage, editLink }) => {
  const [botanicalFamilies, setBotanicalFamilies] = useState<GrowthStage[]>([]);
  const [count, setCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [ordering, setOrdering] = useState<string>("");
  const { t } = useTranslation();
  const { fetchData, response, loading } = useAxios(
    process.env.REACT_APP_API_URL +
      `${link}/?ordering=${ordering}&page=${page}&search=${search}`,
    "GET",
    true,
    "",
    true,
    false
  );

  useEffect(() => {
    if (response) {
      setCount(response.data.count);
      setBotanicalFamilies(response.data.results);
    }
  }, [response]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  const order = (value: string) => {
    setOrdering(value);
  };
  return (
    <Fragment>
      {botanicalFamilies.length > 0 ? (
        <TableContainer>
          <ThemeProvider theme={TableThem}>
            <Table>
              <TableHeader
                setOrdering={order}
                titles={[
                  { name: title, value: "name", align: "left" },
                  {
                    name: t("Map.Description"),
                    value: "description",
                    align: "center",
                  },
                  title !== t("Tree Species.Botanical family")
                    ? {
                        name: t("Department.Status"),
                        value: "is_active",
                        align: "center",
                      }
                    : {
                        name: "",
                        value: "",
                        align: "center",
                      },
                ]}
              />
              <TableBody>
                {botanicalFamilies.map((botanicalFamily: GrowthStage) => (
                  <TableRow key={botanicalFamily.slug}>
                    <BotanicalFamilyTableItem
                      editLink={editLink}
                      link={link}
                      title={title}
                      deleteMessage={deleteMessage}
                      botanicalFamilies={botanicalFamily}
                      fetchData={() => {
                        fetchData({});
                      }}
                      key={botanicalFamily.slug}
                    />
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter
                style={{ border: "none", height: "70px", position: "relative" }}
              >
                <Box
                  sx={{ flexShrink: 0 }}
                  style={{ position: "absolute", left: "0px", top: "20px" }}
                >
                  <Stack spacing={2}>
                    <TablePagination
                      count={Math.ceil(count / 10)}
                      handleChange={handleChange}
                    />
                  </Stack>
                </Box>
                <p className="absolute right-0 top-5 text-sm text-default-text">{`${t(
                  "Message.Showing"
                )} ${(page - 1) * 10 + 1} - ${
                  (page - 1) * 10 + botanicalFamilies.length
                } ${t("Message.of")} ${count}`}</p>
              </TableFooter>
            </Table>
          </ThemeProvider>
        </TableContainer>
      ) : (
        <Loading loading={loading} />
      )}
    </Fragment>
  );
};

export default BotanicalFamilyTableContent;
